import { createReducer } from 'typesafe-actions';
import { LIPActions } from '@store/actions';
import { setESIGNPOPUPSTATUS, setESIGNDISCLOSEDACTIVEUSER, setParentModal } from '@store/actions/lip.action';

export interface LIPState {
    esignPopUpState: 'closed' | 'opened' | 'init' | string;
    selctedDisclosureUser: string;
}

export const initState: LIPState = {
    esignPopUpState: 'init',
    selctedDisclosureUser: ''
};

export const lipReducer = createReducer<LIPState, LIPActions>(initState)
    .handleAction(setESIGNPOPUPSTATUS, (state, action) => ({
        ...state,
        esignPopUpState: action.payload
    }))
    .handleAction(setESIGNDISCLOSEDACTIVEUSER, (state, action) => ({
        ...state,
        selctedDisclosureUser: action.payload
    }))
    .handleAction(setParentModal, (state, action) => {
        return { ...state, parent: action.payload, result: 'opened' };
    });
